import {
  parseAsBoolean,
  parseAsString,
  parseAsStringEnum,
  useQueryStates,
} from 'nuqs'

import { SUPPORTED_COUNTRIES } from '@/common/constants/countries'
import { LANGUAGES } from '@/common/constants/languages'

export function useFilterAccounts() {
  return useQueryStates({
    freeSearch: parseAsString,
    tag: parseAsString,
    locale: parseAsStringEnum([...LANGUAGES]),
    country: parseAsStringEnum([...SUPPORTED_COUNTRIES]),
    isActive: parseAsBoolean.withDefault(false),
  })
}
